import type { InboxPage, InboxRepository, PendingSummary } from '@/domain/inbox/Inbox'
import type { MyRequestsPage, MyRequestsRepository } from '@/domain/home/MyRequests'
import type { HomeBlock } from '@/domain/home/HomeBlock'
import type { BudgetRepository, BudgetUse } from '@/domain/home/Budget'
import type { WeekSchedule, WeekScheduleRepository } from '@/domain/home/WeekSchedule'

export const PENDING_ITEMS_PER_KIND = 5
export const NOTIFICATIONS_SHOWN = 3
export const REQUESTS_SHOWN = 3
export const BUDGETS_SHOWN = 3
export const REJECTED_SHOWN_DAYS = 7

export interface HomeLoaders {
  pending: (() => Promise<PendingSummary>) | null
  notifications: (() => Promise<InboxPage>) | null
  requests: (() => Promise<MyRequestsPage>) | null
  budget: (() => Promise<BudgetUse[]>) | null
  week: (() => Promise<WeekSchedule>) | null
}

export function homeLoaders(
  repositories: { inbox: InboxRepository, requests: MyRequestsRepository, budget: BudgetRepository, week: WeekScheduleRepository },
  blocks: readonly HomeBlock[],
  userId: number | null,
  today: string,
): HomeLoaders {
  return {
    pending: blocks.includes('PENDING') ? () => repositories.inbox.pending(PENDING_ITEMS_PER_KIND) : null,
    notifications: blocks.includes('FOR_YOUR_INFORMATION') ? () => repositories.inbox.notifications(NOTIFICATIONS_SHOWN) : null,
    requests: blocks.includes('MY_REQUESTS') && userId !== null
      ? () => repositories.requests.openRequestsOf(userId, REQUESTS_SHOWN, daysBefore(today, REJECTED_SHOWN_DAYS))
      : null,
    budget: blocks.includes('BUDGET') ? () => repositories.budget.mostUsed(today, BUDGETS_SHOWN) : null,
    week: blocks.includes('WEEK_SCHEDULE') ? () => repositories.week.startingOn(today) : null,
  }
}

export function localIsoDate(date: Date): string {
  return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map((part) => String(part).padStart(2, '0')).join('-')
}

export function daysBefore(isoDate: string, days: number): string {
  const [year, month, day] = isoDate.split('-').map(Number)
  return localIsoDate(new Date(year, month - 1, day - days))
}
